import React from "react";
import { Layout, Typography, Row, Col, Divider, ConfigProvider, Button } from "antd";
import { BreadCrumbs } from "../../Components/Layout/BreadCrumbs";
import { Image } from 'antd';
import { UserAddOutlined } from "@ant-design/icons";
import { getCurrentLanguage } from "../../Helpers/RouteHelper";
import { TextService } from "../../Services/TextService";
import { useNavigate } from "react-router";
import Page from "../../Components/Page/Page";
const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const MemberSystemForAssociationsPage: React.FC = () => {
    const GetText = TextService.GetText;
    const navigation = useNavigate();

    const createClick = () => {
        navigation("/" + getCurrentLanguage() + "/CreateUser")
    };

    return (
        <Layout style={{ background: "#fff" }}>
            <Content>
                <ConfigProvider
                    theme={{
                        components: {
                            Typography: {
                                fontSize: 18,
                                lineHeight: 1.7,
                            },
                        },
                    }}
                >
                    <Page pageTitle={GetText("PageTitle_MemberRegister")} metaDescription="Webbaserat medlemsregister för föreningar och förbund. Hantera medlemmar, betalningar och kommunikation enkelt och säkert – GDPR-anpassat och gratis att börja med.">
                        <Typography>

                            <div className="article-block">
                                <div className="article-inner">
                                    <div
                                        style={{
                                            background: "#f0f5ff",
                                            padding: "80px 24px",
                                            borderRadius: 12,
                                            marginBottom: 48,
                                        }}
                                    >
                                        <Row gutter={[32, 32]} align="middle">
                                            <Col xs={24} md={14}>

                                                <BreadCrumbs currentName="Medlemsregister" />


                                                <Title style={{ fontSize: 42, fontWeight: 700, marginBottom: 24 }}>
                                                    Medlemsregister för föreningar – enkelt, automatiserat och gjort för att spara tid
                                                </Title>

                                                <Paragraph style={{ fontSize: 18, marginBottom: 32 }}>
                                                    Ett modernt medlemssystem som hjälper föreningar att hantera medlemmar, avgifter,
                                                    event och kommunikation – allt på ett ställe.
                                                </Paragraph>

                                            </Col>

                                            <Col xs={24} md={10}>
                                                <Image
                                                    src={require('../../Images/Articles/medlemsregister-illustration.png')}
                                                    preview={false}
                                                    style={{ borderRadius: 12, width: "100%" }}
                                                />
                                            </Col>
                                        </Row>
                                    </div>


                                </div></div>

                            <div className="article-block">
                                <div className="article-inner">

                                    <Paragraph>
                                        Att driva en förening ska handla om gemenskap, utveckling och aktiviteter – inte om
                                        administration, Excel-filer och manuella betalningar. Ett modernt medlemssystem gör det
                                        möjligt att hantera medlemmar, avgifter, event och kommunikation på ett sätt som både
                                        sparar tid och minskar risken för fel. OneFront360 är utvecklat för föreningar som vill
                                        få full kontroll över sin verksamhet utan att behöva lägga timmar på administration.
                                    </Paragraph>

                                    <Divider />

                                    <Title level={2}>Varför ett medlemssystem är avgörande för dagens föreningar</Title>
                                    <Paragraph>
                                        Föreningar växer, medlemmar byts ut, avgifter ska betalas och aktiviteter ska planeras.
                                        Många föreningar fastnar i manuella rutiner som:
                                    </Paragraph>
                                    <ul>
                                        <li>
                                            <Text>Excel-listor som snabbt blir inaktuella</Text>
                                        </li>
                                        <li>
                                            <Text>Medlemsregister som ligger utspridda hos flera personer</Text>
                                        </li>
                                        <li>
                                            <Text>Missade betalningar och svårigheter att följa upp medlemsavgifter</Text>
                                        </li>
                                        <li>
                                            <Text>Kommunikation via flera olika kanaler</Text>
                                        </li>
                                        <li>
                                            <Text>Tidskrävande administration inför event och aktiviteter</Text>
                                        </li>
                                    </ul>
                                    <Paragraph>
                                        Ett digitalt <Text strong>föreningssystem</Text> samlar allt på ett ställe och gör det
                                        enkelt att hantera medlemmar, ekonomi och kommunikation – även för ideella krafter med
                                        begränsad tid.
                                    </Paragraph>

                                </div></div>
                            <Divider />

                            <div className="article-grey-block">
                                <div className="article-inner">
                                    <Title level={2}>Ett komplett medlemssystem för föreningar</Title>
                                    <Paragraph>
                                        OneFront360 är byggt för att förenkla vardagen för både små och stora föreningar.
                                        Systemet kombinerar medlemsregister, betalningar, eventhantering och kommunikation i en
                                        och samma plattform.
                                    </Paragraph>

                                    <Image
                                        src={require('../../Images/Articles/medlemsregister.png')}
                                        preview={false}
                                        className="removeOnMobile"
                                        alt="OneFront 360 medlemsregister"
                                        style={{
                                            borderRadius: 12,
                                            width: "100%",
                                            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)"
                                        }}
                                    />

                                    <Image
                                        src={require('../../Images/Articles/ny-medlem.png')}
                                        preview={false}
                                        className="removeOnMobile"
                                        alt="OneFront 360 ny medlem formulär"
                                        style={{
                                            borderRadius: 12,
                                            width: "500px",
                                            marginTop: -70,
                                            marginLeft: 30,
                                            boxShadow: "0 8px 24px rgba(0,0,0,0.15), 0 -8px 24px rgba(0,0,0,0.10)"
                                        }}
                                    />

                                    <Title level={3}>Medlemsregister som alltid är uppdaterat</Title>
                                    <Paragraph>
                                        Ett bra <Text strong>medlemsregister för föreningar</Text> ska vara enkelt att använda
                                        och alltid korrekt. I OneFront360 får du:
                                    </Paragraph>
                                    <ul>
                                        <li>
                                            <Text>Full överblick över alla medlemmar</Text>
                                        </li>
                                        <li>
                                            <Text>Kontaktuppgifter, roller och grupper</Text>
                                        </li>
                                        <li>
                                            <Text>Historik över betalningar och aktiviteter</Text>
                                        </li>
                                        <li>
                                            <Text>Möjlighet att importera befintliga register</Text>
                                        </li>
                                        <li>
                                            <Text>Automatisk uppdatering när medlemmar ändrar sina uppgifter</Text>
                                        </li>
                                    </ul>
                                    <Paragraph>
                                        Det gör att du slipper manuellt arbete och minskar risken för fel.
                                    </Paragraph>

                                    <Title level={3}>Automatiserad hantering av medlemsavgifter</Title>
                                    <Paragraph>
                                        Att jaga betalningar är en av de mest tidskrävande uppgifterna i en förening. Med
                                        OneFront360 kan du:
                                    </Paragraph>
                                    <ul>
                                        <li>
                                            <Text>Skicka automatiska betalningspåminnelser</Text>
                                        </li>
                                        <li>
                                            <Text>Ta emot betalningar via kort, Swish eller faktura</Text>
                                        </li>
                                        <li>
                                            <Text>Få full överblick över vilka som betalat</Text>
                                        </li>
                                        <li>
                                            <Text>Skapa återkommande avgifter</Text>
                                        </li>
                                        <li>
                                            <Text>Exportera underlag till bokföring</Text>
                                        </li>
                                    </ul>
                                    <Paragraph>
                                        Det gör att kassören sparar timmar varje månad.
                                    </Paragraph>

                                    <Title level={3}>Event och aktiviteter – planera, boka och ta betalt</Title>
                                    <Paragraph>
                                        Föreningar arrangerar ofta träningar, möten, kurser och andra aktiviteter. Med
                                        OneFront360 kan du:
                                    </Paragraph>
                                    <ul>
                                        <li>
                                            <Text>Skapa event med ett klick</Text>
                                        </li>
                                        <li>
                                            <Text>Låta medlemmar anmäla sig online</Text>
                                        </li>
                                        <li>
                                            <Text>Se deltagarlistor i realtid</Text>
                                        </li>
                                        <li>
                                            <Text>Skicka automatiska påminnelser</Text>
                                        </li>
                                    </ul>
                                    <Paragraph>
                                        Det gör planeringen enklare och minskar risken för missförstånd.
                                    </Paragraph>

                                    <Title level={3}>Kommunikation som når fram</Title>
                                    <Paragraph>
                                        Kommunikation är avgörande för en fungerande förening. I OneFront360 kan du:
                                    </Paragraph>
                                    <ul>
                                        <li>
                                            <Text>Skicka e-post och SMS till grupper eller hela föreningen</Text>
                                        </li>
                                        <li>
                                            <Text>Automatisera utskick vid anmälningar och betalningar</Text>
                                        </li>
                                        <li>
                                            <Text>Schemalägga meddelanden</Text>
                                        </li>
                                        <li>
                                            <Text>Få statistik på öppnings- och klickfrekvens</Text>
                                        </li>
                                    </ul>
                                    <Paragraph>
                                        All kommunikation sker från samma plattform som medlemsregistret, vilket gör det enkelt
                                        att nå rätt personer.
                                    </Paragraph>
                                </div>
                            </div>
                            <Divider />


                            <div className="article-block">
                                <div className="article-inner">
                                    <Title level={2}>Fördelar med ett digitalt föreningssystem</Title>
                                    <Paragraph>
                                        Ett modernt medlemssystem ger flera konkreta fördelar:
                                    </Paragraph>
                                    <ul>
                                        <li>
                                            <Text strong>Mindre administration</Text> – automatisering sparar tid
                                        </li>
                                        <li>
                                            <Text strong>Färre fel</Text> – allt ligger samlat och uppdateras automatiskt
                                        </li>
                                        <li>
                                            <Text strong>Bättre ekonomi</Text> – enklare att följa upp medlemsavgifter
                                        </li>
                                        <li>
                                            <Text strong>Tydligare kommunikation</Text> – alla får rätt information i rätt tid
                                        </li>
                                        <li>
                                            <Text strong>Ökad trygghet</Text> – GDPR-säkert och krypterat system
                                        </li>
                                        <li>
                                            <Text strong>Enklare överlämning</Text> – perfekt för ideella föreningar där roller
                                            byts ofta
                                        </li>
                                    </ul>
                                    <Paragraph>
                                        Det gör att föreningen kan fokusera på verksamheten istället för administrationen.
                                    </Paragraph>

                                    <Title level={3}>Passar alla typer av föreningar</Title>
                                    <Paragraph>
                                        OneFront360 används av föreningar inom:
                                    </Paragraph>
                                    <ul>
                                        <li>
                                            <Text>Kultur</Text>
                                        </li>
                                        <li>
                                            <Text>Intresseorganisationer</Text>
                                        </li>
                                        <li>
                                            <Text>Villa/samfällighetsföreningar</Text>
                                        </li>
                                        <li>
                                            <Text>Ideella organisationer</Text>
                                        </li>
                                        <li>
                                            <Text>Idrott</Text>
                                        </li>
                                        <li>
                                            <Text>Hembygdsföreningar</Text>
                                        </li>
                                        <li>
                                            <Text>Musikföreningar</Text>
                                        </li>
                                    </ul>
                                    <Paragraph>
                                        Systemet är flexibelt och kan anpassas efter föreningens storlek och behov.
                                    </Paragraph>


                                </div></div>


                            <div className="article-grey-block">
                                <div className="article-inner">

                                    <Title level={2}>
                                        Så hjälper OneFront360 din förening att hantera medlemmar effektivt
                                    </Title>
                                    <Paragraph>
                                        Att <Text strong>hantera medlemmar</Text> handlar inte bara om att ha ett register. Det
                                        handlar om att skapa struktur, trygghet och enkelhet för både styrelse och medlemmar.
                                    </Paragraph>
                                    <Paragraph>Med OneFront360 får du:</Paragraph>
                                    <ul>
                                        <li>
                                            <Text>Ett centralt medlemsregister</Text>
                                        </li>
                                        <li>
                                            <Text>Automatiska processer för betalningar</Text>
                                        </li>
                                        <li>
                                            <Text>Enklare administration av grupper och sektioner</Text>
                                        </li>
                                        <li>
                                            <Text>Möjlighet att delegera ansvar till ledare eller gruppansvariga</Text>
                                        </li>
                                        <li>
                                            <Text>Full spårbarhet och historik</Text>
                                        </li>
                                    </ul>
                                    <Paragraph>
                                        Det gör att föreningen fungerar bättre – även när personer byts ut.
                                    </Paragraph>

                                </div></div>

                            <div className="article-block">
                                <div className="article-inner">

                                    <Title level={2}>Kom igång snabbt – utan teknisk kunskap</Title>
                                    <Paragraph>
                                        OneFront360 är byggt för att vara enkelt. Du kan:
                                    </Paragraph>
                                    <ul>
                                        <li>
                                            <Text>Registrera ett konto på några minuter</Text>
                                        </li>
                                        <li>
                                            <Text>Importera ditt medlemsregister</Text>
                                        </li>
                                        <li>
                                            <Text>Skapa grupper och avgifter direkt</Text>
                                        </li>
                                        <li>
                                            <Text>Börja ta emot betalningar samma dag</Text>
                                        </li>
                                    </ul>
                                    <Paragraph>
                                        Systemet kräver ingen installation och fungerar på dator, mobil och surfplatta.
                                    </Paragraph>

                                    <Divider />

                                    <Button size="large" onClick={createClick} type="primary">{GetText("Start_Register")}<UserAddOutlined /></Button>

                                </div>
                            </div>

                            <div className="article-grey-block">
                                <div className="article-inner">

                                    <Title level={2}>
                                        Sammanfattning: Ett medlemssystem som förenklar hela föreningens vardag
                                    </Title>
                                    <Paragraph>
                                        OneFront360 är ett komplett <Text strong>medlemssystem för föreningar</Text> som gör det
                                        enkelt att:
                                    </Paragraph>
                                    <ul>
                                        <li>
                                            <Text>Hantera medlemmar</Text>
                                        </li>
                                        <li>
                                            <Text>Ta emot och följa upp medlemsavgifter</Text>
                                        </li>
                                        <li>
                                            <Text>Planera och administrera event</Text>
                                        </li>
                                        <li>
                                            <Text>Kommunicera effektivt</Text>
                                        </li>
                                        <li>
                                            <Text>Spara tid och minska administration</Text>
                                        </li>
                                    </ul>
                                    <Paragraph>
                                        Det är ett modernt, säkert och användarvänligt föreningssystem som passar både små och
                                        stora föreningar.
                                    </Paragraph>
                                </div></div>

                        </Typography>
                    </Page>
                </ConfigProvider>
            </Content >
        </Layout >
    );
};

export default MemberSystemForAssociationsPage;
